<template>
  <div :class="computedClass">
    <JadeLabel
      :error="error"
      :optional="optional"
      :disabled="disabled"
      :hidden="hideLabel"
      :htmlFor="label"
    >
      {{ label }}
    </JadeLabel>
    <select
      :id="label"
      :arial-label="label"
      :arial-required="!optional"
      :disabled="disabled"
      @change="$event => $emit('onChange', $event.target.value)"
    >
      <option
        hidden
        value=""
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="isString(option) ? option : `${option.value}-option`"
        :selected="optionValue(option) === defaultValue"
        :aria-selected="optionValue(option) === defaultValue"
        :disabled="isString(option) ? false : option.disabled"
        :value="optionValue(option)"
      >
        {{ isString(option) ? option : option.label }}
      </option>
    </select>
    <JadeSupportText
      :error="error"
      :disabeld="disabled"
    >
      {{ supportText }}
    </JadeSupportText>
  </div>
</template>

<script>
import JadeLabel from '../JadeLabel'
import JadeSupportText from '../JadeSupportText'

import SIZE_ENUM from '../enums/sizes.enum'

export default {
  name: 'JadeSelect',
  components: {
    JadeLabel,
    JadeSupportText
  },
  props: {
    supportText: String,
    defaultValue: String,
    disabled: Boolean,
    optional: Boolean,
    error: Boolean,
    hideLabel: Boolean,
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Escolha uma opção'
    },
    size: {
      type: String,
      default: SIZE_ENUM.LARGE,
      validation: s => [SIZE_ENUM.MEDIUM, SIZE_ENUM.LARGE].includes(s)
    }
  },
  computed: {
    computedClass () {
      return {
        'jade-select': true,
        'is-disabeld': this.disabled,
        'is-errored': this.error,
        [`is-${this.size}`]: this.size
      }
    }
  },
  methods: {
    isString (option) {
      return typeof option === 'string'
    },
    optionValue (option) {
      return this.isString(option) ? option : option.value
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/select.css';
</style>
